import { Component, Host, Element, State, h } from "@stencil/core";
import { linkWrapperIgnoreAttribute } from "./attributes";

@Component({
    tag: "ux-iws-link-wrapper",
    styleUrl: "link-wrapper.scss",
    shadow: false,
})
export class LinkWrapper {
    @Element() element: HTMLUxIwsLinkWrapperElement;

    @State() hasLink: boolean = true;
    @State() isVisible: boolean = false;

    connectedCallback() {
        this.hasLink = this.element.querySelector("a") !== null;
    }

    private clickLink = (event: Event): void => {
        const target = event.target as HTMLElement;
        const hasIgnoreAttribute = target.hasAttribute(
            linkWrapperIgnoreAttribute
        );
        const hasParentIgnoreAttribute = !!target.closest(
            `*[${linkWrapperIgnoreAttribute}]`
        );
        const isIgnoredElement =
            ["A", "BUTTON", "INPUT"].indexOf(target.tagName) > -1;
        if (hasIgnoreAttribute || isIgnoredElement || hasParentIgnoreAttribute)
            return;
        event.preventDefault();
        this.element.querySelector("a").click(); // click() respects the target-attribute on the link
    };

    render() {
        return (
            <Host
                onClick={(event: Event) => this.clickLink(event)}
                class={{
                    ["ux-iws-link-wrapper"]: true,
                    ["ux-iws-link-wrapper--with-link"]: this.hasLink,
                }}
            >
                <slot />
            </Host>
        );
    }
}
